/* eslint-disable import/first, import/newline-after-import */

import 'components/resources/show/resource-show-preview/resource-show-preview';
import(
  /* webpackChunkName: "pricing-block-styles" */
  /* webpackPrefetch: true */
  'components/util/pricing-block/pricing-block'
);

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import ResourceShowPreviewController from 'components/resources/show/resource-show-preview/resource-show-preview-controller';
EezyStimulusApplication.register('resource-show-preview', ResourceShowPreviewController);

import(
  /* webpackChunkName: "pinterest-share-controller" */
  /* webpackPreload: true */
  'components/resources/pinterest/pinterest-share-controller'
).then((controller) => {
  EezyStimulusApplication.register('pinterest-share', controller.default);
});

import(
  /* webpackChunkName: "pricing-modal-controller" */
  /* webpackPrefetch: true */
  'components/pricing/pricing-modal/pricing-modal-controller'
).then((controller) => {
  EezyStimulusApplication.register('pricing-modal', controller.default);
});

import(
  /* webpackChunkName: "pricing-plan-block-controller" */
  /* webpackPrefetch: true */
  'components/pricing/pricing-main/pricing-plan-block-controller'
).then((controller) => {
  EezyStimulusApplication.register('pricing-plan-block', controller.default);
});
